import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import ReactFocusLock from 'react-focus-lock';
import ScrollLock from 'react-scrolllock';
import invariant from 'tiny-invariant';
import { defaultFocusLockSettings } from '../../constants';
// Thin wrapper over react-focus-lock. This wrapper only exists to ensure API compatibility.
// This component should be deleted during https://ecosystem.atlassian.net/browse/AK-5658
var FocusLock = /*#__PURE__*/function (_Component) {
  _inherits(FocusLock, _Component);
  var _super = _createSuper(FocusLock);
  function FocusLock() {
    _classCallCheck(this, FocusLock);
    return _super.apply(this, arguments);
  }
  _createClass(FocusLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        isFocusLockEnabled = _this$props.isFocusLockEnabled,
        autoFocusFirstElem = _this$props.autoFocusFirstElem;
      if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production' && !process.env.CI) {
        invariant(typeof autoFocusFirstElem === 'boolean', '@atlaskit/drawer: Passing a function as autoFocus is deprecated. Instead call focus on the element ref or use the autofocus property.');
      }
      if (typeof autoFocusFirstElem === 'function' && isFocusLockEnabled) {
        var elem = autoFocusFirstElem();
        if (elem && elem.focus) {
          elem.focus();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        isFocusLockEnabled = _this$props2.isFocusLockEnabled,
        autoFocusFirstElem = _this$props2.autoFocusFirstElem,
        shouldReturnFocus = _this$props2.shouldReturnFocus,
        children = _this$props2.children;
      return /*#__PURE__*/React.createElement(ReactFocusLock, {
        disabled: !isFocusLockEnabled,
        autoFocus: !!autoFocusFirstElem,
        returnFocus: shouldReturnFocus
      }, /*#__PURE__*/React.createElement(ScrollLock, null, children));
    }
  }]);
  return FocusLock;
}(Component);
_defineProperty(FocusLock, "defaultProps", _objectSpread({}, defaultFocusLockSettings));
export { FocusLock as default };